import { IVirtualMachinesSelector } from './newModel'

export const convertVMFilterParamsToQueryParams = (searchParams) => {
  if (!searchParams) {
    return ''
  }

  let query_params = ''
  Object.entries(searchParams)?.forEach(([key, value]) => {
    if (key === 'tenant_id') {
      return
    }

    if (key && value && value !== 'all') {
      if (key === 'user_id') {
        query_params += `&owner=${value}`
      } else {
        query_params += `&${key}=${value}`
      }
    }
  })
  return query_params
}

/**
 * Util function to check if the VM is using only simple network
 * Simple network or L2-only network VMs don't have addresses
 * @param vm
 * @returns true if the VM is using only simple network
 */
export const isVMUsingOnlySimpleNetwork = (vm: IVirtualMachinesSelector) => {
  return Object.values(vm?.addresses || {}).flatMap((ip) => ip)?.length === 0
}
